import { useEffect, useState } from 'react';

export type ViewportClass = 'mobile' | 'tablet-portrait' | 'split';

function compute(): ViewportClass {
  if (typeof window === 'undefined') return 'mobile';
  const w = window.innerWidth;
  const h = window.innerHeight;
  if (w >= 1024) return 'split';
  if (w >= 768 && h > w) return 'tablet-portrait';
  return 'mobile';
}

export function useViewportClass(): ViewportClass {
  const [v, setV] = useState<ViewportClass>(compute);
  useEffect(() => {
    const onResize = () => setV(compute());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return v;
}
